// React
import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";

// MUI
import { 
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import FolderOpenIcon from '@mui/icons-material/FolderOpen';



export default function ListStudentsTable({ students, selected, setSelected }) {

    // Component
    return (
        <Table className="student-table" stickyHeader sx={{borderCollapse: "separate"}}>

            {/* Header Row */}
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Student ID</TableCell>
                    <TableCell>Use Webcam?</TableCell>
                    <TableCell>Recordings</TableCell>
                </TableRow>
            </TableHead>

            {/* Body */}
            <TableBody>
                {(students || []).map((student) => (
                    <TableRow key={student.id} sx={{
                        // Make selected row sticky
                        position: student.id === selected?.id ? "sticky" : "revert",
                        top:      student.id === selected?.id ? "41px" : "revert",
                        bottom:   student.id === selected?.id ? 0        : "revert",
                        zIndex:   student.id === selected?.id ? 9        : "revert",
                        // Highlight selected row
                        backgroundColor: student.id === selected?.id ? "#ceebfd" : "white",
                    }}>

                        {/* Selection Indicator */}
                        <TableCell sx={{paddingRight: 0}}>
                            <Box display="flex" justifyContent="center" alignItems="center">
                                { student.id === selected?.id ? <RemoveRedEyeIcon sx={{color: "#4447ad"}} /> : null }
                            </Box>
                        </TableCell>

                        {/* Student Username */}
                        <TableCell>
                            <Button className="student-link" onClick={() => setSelected(student)}>
                                <AccountCircleIcon sx={{marginRight: 1}}/>
                                <Typography fontWeight={student.id === selected?.id ? "bolder" : "unset"}>
                                    {student.username}
                                </Typography>
                            </Button>
                        </TableCell>

                        {/* Webcam Permissions */}
                        <TableCell>
                            { student.use_webcam ? "Yes" : "No" }
                        </TableCell>

                        {/* Recordings */}
                        <TableCell>
                            <Link to={`${encodeURIComponent(student.username)}/recordings`} style={{ color: 'rgb(68, 71, 173)' }} aria-label={`Recordings for ${student.username}`}>
                                <FolderOpenIcon />
                            </Link>
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};
